import { Link } from 'react-router-dom';
import { Stack } from 'rsuite';
import { useAppSelector } from '../store/hook';
import { selectHasGroup } from '../store/groupSlice';
import { ReactElement, useEffect, useState } from 'react';

interface IProps {
  stackProps?: Record<string, string>;
  title?: string;
  logo?: ReactElement;
  link?: string;
  width?: number | string;
  titleStyle?: Record<string, string | number>;
  subtitle?: string;
  subTitleStyle?: Record<string, string | number>;
  isExpanded?: boolean;
}
export const Brand = (props: IProps) => {
  const isExpanded = props.isExpanded;
  const titleStyle = props.titleStyle;
  const subTitleStyle = props.subTitleStyle;
  const hasGroup = useAppSelector(selectHasGroup);
  const styleBrand = {
    adding: '10px 18px',
    overflow: 'hidden',
    width: props.width || '',
    height: '100%'
  };
  const [classArr, setClassArr] = useState<string[]>(['']);
  useEffect(() => {
    const arr = ['logo-brand'];
    if (isExpanded) {
      arr.push('expanded');
    }
    if (hasGroup) {
      arr.push('has-side-menu');
    }
    setClassArr(arr);
  }, [isExpanded, hasGroup]);
  return (
    <Stack
      style={styleBrand}
      {...props.stackProps}
      alignItems="center"
      spacing={'6px'}
      className={classArr.join(' ')}
    >
      {props.logo}
      {isExpanded && (
        <Link
          to={props.link || '/'}
          style={{ textDecoration: 'none', lineHeight: '20px' }}
        >
          <span style={titleStyle}>{props.title}</span>
          <span style={subTitleStyle}>{props.subtitle}</span>
        </Link>
      )}
    </Stack>
  );
};

export default Brand;
